import { useMutation } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'

interface DeleteFloatingContextSourceVariables {
  scheduleId: number
  contextSourceId: number
}

const deleteFloatingContextSource = async ({ scheduleId, contextSourceId }: DeleteFloatingContextSourceVariables) => {
  const response = await sendToApi(`/schedules/${scheduleId}/content_context_sources/${contextSourceId}`, {
    method: 'DELETE',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to delete context source')
  }
}

export const useDeleteFloatingContextSource = () => {
  return useMutation<void, Error, DeleteFloatingContextSourceVariables>(deleteFloatingContextSource)
}
